import React from "react";


export default function SubscribeDialog({ open, onClose, onOpenAccount }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e)=>e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <div className="modal-title">Get More Credits</div>
            <div className="subtle text-sm">Choose a plan to continue generating songs</div>
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="pricing-grid">
            <div className="price-card">
              <div className="price-title">Basic</div>
              <div className="price-amount">$9/mo</div>
              <ul className="price-list">
                <li>100 song generations / month</li>
                <li>Standard genres & moods</li>
                <li>Email support</li>
              </ul>
              <button className="btn-primary" onClick={()=>{ onClose(); onOpenAccount("basic"); }}>Choose Basic</button>
            </div>
            <div className="price-card featured">
              <div className="price-title">Pro</div>
              <div className="price-amount">$19/mo</div>
              <ul className="price-list">
                <li>Unlimited generations</li>
                <li>Advanced styles</li>
                <li>Priority support</li>
              </ul>
              <button className="btn-primary" onClick={()=>{ onClose(); onOpenAccount("pro"); }}>Choose Pro</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

